<template>
    <div class="hidden">
        {{logout()}}
    </div>
</template>


<script>
export default {
    data(){
        return{
            
        }
    },  
    methods: {
        async logout(){
            try{ 
                await this.$store.dispatch('ActionLogout')
                this.$router.push('/')
            } catch(e){
                console.log(e)
            }
        },
    },  
    async beforeCreate(){

    }
}
</script>